import React, { useCallback, useMemo } from 'react';
import ItemContent from '../../../../components/ItemContent/ItemContent';
import useDescLangs from '../../../../utils/useDescLangs';
import { useTranslation } from 'react-i18next';
import { NSLinks } from '../../../../types/interfaces/NSLinks';
import { IEditForm } from '../../../../types/interfaces/IEditForm';
import LabelWithPars from '../../../../components/LabelWithPars/LabelWithPars';
import tPaths from '../../../../utils/tPaths';
import { endpoints } from '../../../../utils/endpoints';
import { EPaths } from '../../../../types/enums/EPaths';
import { CircularProgress } from '@material-ui/core';
import { collectTypes } from '../../../../utils/js';

const LegalLinks = ({ editable }: { editable: boolean }) => {
  const { languagesList, reduceLangsList } = useDescLangs();
  const { t } = useTranslation();

  const descriptionMapper = useCallback(
    (data: NSLinks.IData, key: string): IEditForm[][] => {
      const items: IEditForm[][] = data.links.map((item) => [
        {
          type: 'title',
          label: item._id,
          fieldName: item._id,
        },
        {
          type: 'input',
          fieldName: item._id + ':specialTitle',
          label: <LabelWithPars label={t(tPaths.editFormLabels.subject)} info={key.toUpperCase()} />,
          initialValue: item.title[key],
        },
        {
          type: 'input',
          fieldName: item._id + ':specialUrl',
          label: <LabelWithPars label={t(tPaths.editFormLabels.url)} info={key.toUpperCase()} />,
          initialValue: item.URL[key],
        },
      ]);
      return items;
    },
    [t],
  );

  const tabs = useMemo(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList],
  );

  const tabsContentMapper = useCallback(
    (data: NSLinks.IData) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: descriptionMapper(data, cv.key),
        }),
        {},
      ),
    }),
    [descriptionMapper, languagesList],
  );

  const updateDataFormatter = useCallback(
    (fields: any) => {
      return {
        links: collectTypes(fields).map((t: any) => ({
          _id: t,
          title: reduceLangsList(fields, t + ':specialTitle'),
          URL: reduceLangsList(fields, t + ':specialUrl'),
        })),
      };
    },
    [reduceLangsList],
  );

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          path={EPaths.LegalLinks}
          title={t(tPaths.itemContent.editLinks)}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          apiUrl={endpoints.links}
          backButton={false}
          editable={editable}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default LegalLinks;
